import { discoverOAuthLogin } from '../../../services/modules/oauth/oauth.repository';
import { OAuthEmailFormValues } from '../components/OAuthEmailPanel/hooks/useOAuthEmailForm';
import useOAuthRequestError from './useOAuthRequestError';

interface UseOAuthDiscoverParams {
  onPassword: (email: string) => void;
  onExpired: (errorMessage: string) => void;
}

interface UseOAuthDiscoverReturn {
  handleDiscover: (values: OAuthEmailFormValues) => Promise<void>;
}

const useOAuthDiscover = (
  oauthRequestId: string,
  { onPassword, onExpired }: UseOAuthDiscoverParams,
): UseOAuthDiscoverReturn => {
  const handleRequestError = useOAuthRequestError(onExpired);

  const handleDiscover = async ({ email }: OAuthEmailFormValues) => {
    const response = await discoverOAuthLogin({ email, oauth_request_id: oauthRequestId });

    if (response.ok && response.data?.method === 'sso') {
      window.location.href = response.data.start_url;
      return;
    }

    if (response.ok && response.data?.method === 'password') {
      onPassword(email);
      return;
    }

    handleRequestError(response);
  };

  return { handleDiscover };
};

export default useOAuthDiscover;
